export const SET_ACTIVE_SERVICE = "SET_ACTIVE_SERVICE";

export const setActiveService = (activeServiceId) => {
  return (dispatch) => {
    dispatch({
      type: SET_ACTIVE_SERVICE,
      payload: activeServiceId,
    });
  };
};
